export default __webpack_public_path__ + "static/media/12 Track 12.4cc3380f.mp3";